import MainApi from "./axiosInstance";

class ContactService {
    contactUs(payload: any) {
        return MainApi.post(`/contact-us`, payload)
    }
}

export default new ContactService()